<button class="lua-bouton-icone" 
	[ngClass]="{
		'size-s': size === 'small',
		'size-m': size === 'medium',
		'size-l': size === 'large',
		disabled: isDisabled
	}" 
	(click)="isDisabled ? null : handleClick($event)" 
	type="button">
	<lua-icone *ngIf="!isIcon" [color]="color" [iconName]="iconName" [fontSize]="fontSize" [isIcon]="isIcon" [mode]="mode"></lua-icone>
	<lua-icone *ngIf="isIcon" [color]="color" [customIconName]="iconName" [width]="fontSize" [width]="fontSize" [isIcon]="isIcon" [mode]="mode"></lua-icone>
</button>